export const BELIEFS = [
  {
    id: 'bible',
    title: 'Holy Bible',
    body:
      'The Holy Bible, and only the Bible, is the authoritative Word of God. It alone is the final authority in determining all doctrinal truths. In its original writing, it is inspired, infallible and inerrant.',
    refs: 'II Timothy 3:16; II Peter 1:20-21; Proverbs 30:5; Romans 16:25-26',
  },
  {
    id: 'trinity',
    title: 'Trinity',
    body:
      'There is one God, eternally existent in three persons: Father, Son and Holy Spirit. These three are coequal and co-eternal.',
    refs: 'I John 5:7; Genesis 1:26; Matthew 3:16-17, 28:19; Luke 1:35; Isaiah 9:6; Hebrews 3:7-11',
  },
  {
    id: 'jesus-christ',
    title: 'Jesus Christ',
    body:
      'Jesus Christ is God the Son, the second person of the Trinity. On earth, Jesus was 100% God and 100% man. He is the only man ever to have lived a sinless life. He was born of a virgin, lived a sinless life, performed miracles, died on the cross for mankind and thus, atoned for our sins through the shedding of His blood. He rose from the dead on the third day according to the Scriptures, ascended to the right hand of the Father, and will return again in power and glory.',
    refs: 'John 1:1, 14, 20:28; I Timothy 3:16; Isaiah 9:6; Philippians 2:5-6; I Timothy 2:5',
  },
  {
    id: 'virgin-birth',
    title: 'Virgin Birth',
    body:
      'Jesus Christ was conceived by God the Father, through the Holy Spirit (the third person of the Trinity) in the virgin Mary\'s womb; therefore, He is the Son of God.',
    refs: 'Matthew 1:18, 25; Luke 1:35; Isaiah 7:14; Luke 1:27-35',
  },
  {
    id: 'redemption',
    title: 'Redemption',
    body:
      'Man was created good and upright, but by voluntary transgression he fell; his only hope of redemption is in Jesus Christ, the Son of God.',
    refs: 'Genesis 1:26-31, 3:1-7; Romans 5:12-21',
  },
  {
    id: 'salvation',
    title: 'Salvation',
    body:
      'We are saved by grace through faith in Jesus Christ: His death, burial, and resurrection. Salvation is a gift from God, not a result of our good works or of any human efforts.',
    refs: 'Ephesians 2:8-9; Galatians 2:16, 3:8; Titus 3:5; Romans 10:9-10; Acts 16:31; Hebrews 9:22',
  },
  {
    id: 'repentance',
    title: 'Repentance',
    body:
      'Repentance is the commitment to turn away from sin in every area of our lives and to follow Christ, which allows us to receive His redemption and to be regenerated by the Holy Spirit. Thus, through repentance we receive forgiveness of sins and appropriate salvation.',
    refs: 'Acts 2:21, 3:19; I John 1:9',
  },
  {
    id: 'sanctification',
    title: 'Sanctification',
    body:
      'Sanctification is the ongoing process of yielding to God\'s Word and His Spirit in order to complete the development of Christ\'s character in us. It is through the present ministry of the Holy Spirit and the Word of God that the Christian is enabled to live a Godly life.',
    refs: 'I Thessalonians 4:3, 5:23; II Corinthians 3:18, 6:14-18; II Thessalonians 2:1-3; Romans 8:29, 12:1-2; Hebrews 2:11',
  },
  {
    id: 'blood',
    title: 'Jesus\' Blood',
    body:
      'The Blood that Jesus Christ shed on the Cross of Calvary was sinless and is 100% sufficient to cleanse mankind of all sin. Jesus allowed Himself to be punished for both our sinfulness and our sins, enabling all those who believe to be free from the penalty of sin, which is death.',
    refs: 'I John 1:7; Revelation 1:5, 5:9; Colossians 1:20; Romans 3:10-12, 23, 5:9; John 1:29',
  },
  {
    id: 'indwelling',
    title: 'Jesus Christ Indwells All Believers',
    body:
      'Christians are people who have invited the Lord Jesus Christ to come and live inside them by His Holy Spirit. They relinquish the authority of their lives over to him thus making Jesus the Lord of their life as well as Savior. They put their trust in what Jesus accomplished for them when He died, was buried, and rose again from the dead.',
    refs: 'John 1:12; John 14:17, 23; John 15:4; Romans 8:11; Revelation 3:20',
  },
  {
    id: 'baptism-spirit',
    title: 'Baptism in the Holy Spirit',
    body:
      'Given at Pentecost, it is the promise of the Father, sent by Jesus after His Ascension, to empower the Church to preach the Gospel throughout the whole earth.',
    refs: 'Joel 2:28-29; Matthew 3:11; Mark 16:17; Acts 1:5, 2:1-4, 17, 38-39, 8:14-17, 10:38, 44-47, 11:15-17, 19:1-6',
  },
  {
    id: 'gifts-spirit',
    title: 'The Gifts of the Holy Spirit',
    body:
      'The Holy Spirit is manifested through a variety of spiritual gifts to build and sanctify the church, demonstrate the validity of the resurrection, and confirm the power of the Gospel. All believers are commanded to earnestly desire the manifestation of the gifts in their lives. These gifts always operate in harmony with the Scriptures and should never be used in violation of Biblical parameters.',
    refs: 'Hebrews 2:4; Romans 1:11, 12:4-8; Ephesians 4:16; I Timothy 4:14; II Timothy 1:6-7; I Corinthians 12:1-31, 14:1-40; I Peter 4:10',
  },
  {
    id: 'church',
    title: 'The Church',
    body:
      'The church is the Body of Christ, the habitation of God through the Spirit, with divine appointments for the fulfillment of Jesus\' Great Commission. Every person who is born of the Spirit is an integral part of the church as a member of the body of believers. There is a spiritual unity of all believers in our Lord Jesus Christ.',
    refs: 'Ephesians 1:22, 2:19-22; Hebrews 12:23; John 17:11, 20-23',
  },
];
